import React from 'react';

import { styled } from '@mui/material/styles';

const Container = styled('section')`
  background-color: white;

  .long-copy {
    margin-bottom: 30px;
  }
`;

type Props = {
  className?: string;
};

const Fleet = ({ className }: Props) => (
  <Container className={className} id='fleet'>
    <div className='row'>
      <h2>Fleet / Delivery</h2>
      <p className='long-copy'>
        Our fleet of Terex front discharge mixers allow our drivers to control the chute from inside the cab.
        They are equipped with GPS tracking and dispatch systems for safe, timely deliveries.
      </p>
    </div>
  </Container>
);

export default Fleet;
